<template>
  <div>
    <quotationTable
      :tabShow="'lose'"
      :unfixedTableThead="unfixedTableThead"
      :tableData="tableData"
      :totalNum="totalNum"
      @handleClick="handleClick"
      @child-event="getLists"
    ></quotationTable>
  </div>
</template>

<script>
import quotationTable from "../../components/quotationTable.vue";
import { querySeekPageForSupplierLists } from "@/app/inquiry/api/all";
export default {
  components: {
    quotationTable
  },
  data() {
    return {
      tableData: [],
      totalNum: 0,
      unfixedTableThead: [
        {
          label: "询价单编号",
          prop: "seekCode",
          width: "120",
          checked: true,
          align: "left",
          fixed: "left"
        },
        {
          label: "询价标题",
          prop: "seekTitle",
          width: "253",
          checked: true,
          align: "left",
          fixed: "left"
        },
        {
          label: "供应商",
          prop: "supplierName",
          width: "210",
          checked: true,
          align: "left"
        },
        {
          label: "采购单位",
          prop: "purchaseOrgName",
          width: "210",
          checked: true,
          align: "left"
        },
        {
          label: "询价总金额(元)",
          prop: "referenceAmount",
          width: "120",
          checked: true,
          align: "right",
          type: "num"
        },
        {
          label: "询价截止时间",
          prop: "seekOffTime",
          width: "150",
          checked: true,
          align: "left"
        }
      ]
    };
  },
  methods: {
    handleClick(row, value) {
      sessionStorage.setItem(
        "inquiryPathData",
        JSON.stringify({
          path: "lose",
          label: "已失效"
        })
      );
      if (value === 2) {
        // this.$router.push(
        //   `/inquiry/inquiryDetail/detail/${row.seekId}/${row.seekSupplierId}`
        // );
        this.$router.push(
          {
            path: "/inquiry/inquiryDetail/detail",
            query: {
              seekId: row.seekId,
              supplierId: row.supplierId,
              seekSupplierId: row.seekSupplierId,
              type: "detail"
            }
          }
          // `/inquiry/inquiryDetail/detail/${row.seekId}/${row.seekSupplierId}`
        );
      }
    },
    getLists(data) {
      let openId = JSON.parse(localStorage.getItem("userInfo")).openId || 0;

      querySeekPageForSupplierLists({
        ...data,
        quoteType: 3,
        openId: openId,
        isShowPageLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          this.tableData = res.data.data.rows;
          this.totalNum = res.data.data.recordsTotal;
        }
      });
    }
  }
};
</script>
